import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';

interface Props {
  orbs: string[]; // literal classNames for the background orb divs
  children: ReactNode;
}

// Page shell shared by every portfolio showcase page: dark background,
// fixed header, background orb effects + grid, centered content, footer.
export function PortfolioShell({ orbs, children }: Props) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-dark w-full overflow-hidden">
      <Header />

      <main className="pt-24 sm:pt-32 pb-20">
        {/* Background Effects */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
          {orbs.map((cls, i) => (
            <div key={i} className={cls} />
          ))}
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:64px_64px]" />
        </div>

        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}

// Centered section heading with flanking gradient rules.
export function SectionDivider({ title, large }: { title: string; large?: boolean }) {
  return (
    <div className={`flex items-center gap-4 ${large ? 'mb-16' : 'mb-10'}`}>
      <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent flex-1" />
      <h2
        className={
          large
            ? 'text-3xl md:text-4xl font-bold font-heading text-text-primary text-center'
            : 'text-2xl sm:text-3xl font-bold font-heading text-text-primary text-center'
        }
      >
        {title}
      </h2>
      <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent flex-1" />
    </div>
  );
}
